"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalData = void 0;
class GlobalData {
    static get assetsBasePath() {
        return "./assets/";
    }
    static getLangPath() {
        return `${GlobalData.assetsBasePath}${GlobalData.currentLang}/`;
    }
    static getPagePath(pageNum) {
        return `${GlobalData.assetsBasePath}pages/${pageNum}/`;
    }
    /** Convert a sound path from story XML (e.g. "assets/sounds/1.mp3") to a
     *  browser-relative URL pointing at the correct language sounds folder. */
    static getSoundUrl(soundPath) {
        var _a;
        const filename = (_a = soundPath.split('/').pop()) !== null && _a !== void 0 ? _a : '';
        return `${GlobalData.getLangPath()}sounds/${filename}`;
    }
    /** Play a short UI sound from dist/assets/sounds/<name>. Fire-and-forget. */
    static playUiSound(name) {
        const audio = new Audio(`${GlobalData.assetsBasePath}sounds/${name}`);
        audio.play().catch(() => { });
    }
}
exports.GlobalData = GlobalData;
GlobalData.currentLang = "eng";
GlobalData.pages = [];
GlobalData.labels = {};
GlobalData.counter = 0; // 0-based index into pages[] (pages 1-27)
